<template>
  <BaseModalWindow :header="false">
    <div class="add">
      <div class="add__header">
        <h2 class="add__header-title">Добавление товара в подкатегорию</h2>
        <div class="add__header-line"></div>
        <span class="close"
        @click="cancel"
      ></span>
      </div>
      <div class="sort">
        <div class="sort__search">
          <LoupeIcon class="sort__search-icon"/>
          <input
            type="text"
            class="sort__search-input"
            placeholder="Поиск"
            @input="searchProduct"
            style="width: 100%; margin-bottom: 24px; border: 1px solid #000000;"
          >
        </div>
        <!-- <SortIcon @sort="sortList"/> -->
      </div>
      <div class="add__products products">
        <ul class="products__list">
          <li
            class="products__list-item"
            v-for="(item, i) in productList"
            :key="i"
          >
            {{ item.Name }}
            <input
              type="checkbox"
              class="products__list-checkbox"
              v-model="selectedItem"
              :value="item.Id"
            >
          </li>
        </ul>
      </div>
      <div class="add__buttons buttons">
        <button
          :class="{
            'buttons__save': true,
            'buttons__save buttons__save_disabled': selectedItem.length === 0
          }"
          @click="saveProducts"
        >
          <SaveIconNew/>
          Сохранить
        </button>
        <button class="buttons__cancel" @click="cancel">
          <CancelIcon/>
          Отменить
        </button>
      </div>
    </div>
  </BaseModalWindow>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'

import BaseModalWindow from '@/components/modals/BaseModalWindow'
import LoupeIcon from '@/components/icons/LoupeIcon'
// import SortIcon from '@/components/icons/SortIcon'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'
import CancelIcon from '@/components/icons/CancelIcon.vue'
export default {
  name: 'AddProductSubcategory',
  components: {
    BaseModalWindow,
    LoupeIcon,
    SaveIconNew,
    CancelIcon
  },
  props: {
    productList: {
      type: Array,
      default: () => []
    },
    activityId: {
      type: Number,
      default: null
    },
    subcategoryId: {
      type: Number,
      default: null
    },
    categoryId: {
      type: Number,
      default: null
    }
  },
  setup (props) {
    const store = useStore()
    const selectedItem = ref([])

    const searchProduct = (e) => {
      store.commit('SetM_SearchAddProductList', e.target.value.trim())
    }

    const saveProducts = () => {
      let obj = null
      if (props.activityId.Id === 3 && selectedItem.value.length !== 0) {
        obj = {
          Id: props.subcategoryId,
          Values: selectedItem.value,
          ParentTagId: props.categoryId
        }
        store.commit('SetM_ShowProductAdder', false)
        store.dispatch('SetA_AddProductSubCategoryProduction', obj)
      } else if (props.activityId.Id !== 3 && selectedItem.value.length !== 0) {
        obj = {
          Id: props.subcategoryId,
          Values: selectedItem.value,
          ParentTagId: props.categoryId
        }
        store.commit('SetM_ShowProductAdder', false)
        store.dispatch('SetA_AddProductSubCategorySrvice', obj)
      }
    }
    const cancel = () => {
      store.commit('SetM_ShowProductAdder', false)
    }
    return {
      searchProduct,
      selectedItem,
      cancel,
      saveProducts
    }
  }
}
</script>

<style lang="scss" scoped>
.add {
  &__header {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 16px;

    &-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 22px;
    }

    &-line {
      display: block;
      flex: 1;
      height: 2px;
      background-color: #C8C8C8;
    }
  }

  &__buttons {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
}

.sort {
  width: 100%;
  &__search {
    position: relative;

    &-icon {
      position: absolute;
      right: 10px;
      top: 10px;
    }

    &-input {
      padding: 8px 16px;
      height: 40px;
      width: 310px;
      border: 1px solid #A8A8A8;
      border-radius: 4px;
    }
  }
}

.products {
  width: 100%;
  height: 270px;
  overflow: auto;
  &__list {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      line-height: 22px;
      font-weight: 400;
    }

    &-checkbox {
      width: 18px;
      height: 18px;
      border: 1px solid #A8A8A8;
      cursor: pointer;
    }
  }
}

.buttons {
  position: absolute;
  right: 0px;
  left: 0px;
  bottom: 0px;
  padding: 24px;
  border-top: 2px solid #D6D6D6;
  background-color: #F5F5F5;
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  width: 100%;
  &__cancel, &__save {
    display: flex;
    align-items: center;
    gap: 16px;
    border-radius: 6px;
    width: 200px;
    color: #FFFFFF;
    transition: 0.8s;
    cursor: pointer;
  }

  &__cancel {
    padding: 10px 12px;
    background-color: #C51B0E;
    &:hover {
      background-color: #A11208;
      color: #FFFFFF;
    }
  }

  &__save {
    padding: 12px 10px;
    background-color: #00ABEC;
    &:hover {
      background-color: #0080B0;
      color: #FFFFFF;
    }

    &_disabled {
      background-color: #C8C8C8;
      color: #FFFFFF;
      cursor: not-allowed;

      &:hover {
        background-color: #C8C8C8;
      }
    }
  }
}

:deep(.modal) {
  padding: 24px;
  height: 500px;
  width: 800px;
}
:deep(.modal__content) {
  padding: 0;
  height: 46vh;
}

.close {
  position: relative;
  width: 12px;
  height: 2px;
  transform: rotate(45deg);
  background-color: #000000;
  transition: 0.8s;
  cursor: pointer;
  border-radius: 1px;

  &::after {
    content: '';
    position: absolute;
    right: 0px;
    width: 12px;
    height: 2px;
    transform: rotate(90deg);
    background-color: #000;
    border-radius: 1px;
  }
}
</style>
